"use strict";
/**
 * @module ValueStream
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stream_1 = require("./../../events/stream");
/**
 * Implementation of a value stream
 */
var ValueStreamImpl = /** @class */ (function (_super) {
    __extends(ValueStreamImpl, _super);
    /**
     * Create a new ValueStreamImpl instance
     *
     * @param emitterFactory  an emitter factory. Events are emitted on the stream
     *                        by the {@link ValueStreamProxy}
     * @param selector        the topic selector
     */
    function ValueStreamImpl(emitterFactory, selector) {
        var _this = _super.call(this, emitterFactory) || this;
        _this.selector = selector;
        return _this;
    }
    return ValueStreamImpl;
}(stream_1.StreamImpl));
exports.ValueStreamImpl = ValueStreamImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/topics/value-stream.js
// module id = 1217
// module chunks = 1